import { Box, BoxProps, LoadingWheel, Text } from "@vinomofo/components";
import { useEffect, useState } from "react";

import { CurrencyLabel } from "../currency";
import { useCart } from "../../hooks/use-cart";
import { useStaffDiscount } from "../../hooks/cart/use-staff-discount";

export const CartSubtotal = (props: BoxProps): JSX.Element => {
  const { cart, isLoading } = useCart();
  const { cartItemsRegularPrice, fetchTotalStaffDiscount } = useStaffDiscount(
    cart
  );
  const [subTotal, setSubtotal] = useState(cart.cartAmount);

  useEffect(() => {
    if (cart) {
      fetchTotalStaffDiscount(cart.lineItems);
      const totalRegularPrice = Object.values(cartItemsRegularPrice);
      const prices = totalRegularPrice
        .map((item) => item.totalRegularPrice)
        .reduce((prev, curr) => prev + curr, 0);

      if (subTotal !== prices) {
        setSubtotal(prices);
      }
    }
  }, [cart?.lineItems]);

  useEffect(() => {
    const totalRegularPrice = Object.values(cartItemsRegularPrice);
    const prices = totalRegularPrice
      .map((item) => item.totalRegularPrice)
      .reduce((prev, curr) => prev + curr, 0);

    if (subTotal !== prices) {
      setSubtotal(prices);
    }
  }, [cartItemsRegularPrice]);

  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="space-between"
      alignItems="center"
      padding={3}
      borderTop="1px solid"
      borderTopColor="divider"
      {...props}
    >
      <Text fontWeight={500} color="darkMofo" fontSize="14px">
        Subtotal
      </Text>
      {isLoading ? (
        <LoadingWheel borderWidth="5px" size="2em" />
      ) : (
        <Text fontSize={1} color="text.default" fontWeight={500}>
          <CurrencyLabel amount={subTotal} showFree />
        </Text>
      )}
    </Box>
  );
};
